import { useTableDataFetch } from "./useTableDataFetch";
import { BASE_URL } from "../../../../constant/apiUrl";
import InvitationHistory from "./InvitationHistoryPending";

const AccessInvitationTable = () => {
  const { rows, loading } = useTableDataFetch({
    url: `${BASE_URL}/invitations/find-all`,
    dataTransformer: (data) =>
      data.map((item) => ({
        ...item,
        country: item?.countryName,
      })),
    filterFn: (item) => item.status !== "FAILURE",
    initialFetch: true,
  });

  return (
    <InvitationHistory
      header={"Access:invitation history"}
      tableData={rows}
      loading={loading}
    />
  );
};
export default AccessInvitationTable;
